import { useDailyMasterOtpQuery } from "generated/graphql"
import React from "react"

const MasterOtp = () => {
  const { data } = useDailyMasterOtpQuery()
  const otp = data?.dailyMasterOtp?.toString()

  // add space in middle of top 123456 -> 123 456
  const otpWithSpace = otp?.replace(/(\d{3})(\d{3})/, "$1 $2")
  return (
    <div className="vt-otp">
      <span>
        Today's OTP - <span className="vt-highlight">{otpWithSpace}</span>
      </span>
    </div>
  )
}

export default MasterOtp
